export const data = {
  app: "Shriyansh Bhargava",
  logo: "Logo",
  home: {
    intro: "A passionate Front-end React Developer based in Indore, India. 📍",
  },
  about: {
    aboutTitle: "about",
    background: "background",
    skills: "Here are a few technologies I’ve been working with recently:",
  },
  experience: {
    experienceTitle: "experience",
  },
  projects: {
    projectsTitle: "work",
  },
  contact: {
    contactTitle: "contact",
    content: "Designed & Developed by",
  },

  notFound: {
    nfCode: "404",
    nfMessage: "This page could not be found.",
    nfHome: "Go Home",
  },
};
